@if (publicnode$ | async; as item) {
  @if(item.uid==="SeqirusWhyFluDetailComponent"){
<section class="Home">
    <div class="home_whyflu360">
    <div class="homepageContainer1"[innerHTML]="item.h4content">
    </div>
    <div class="homepageContainer2" [innerHTML]="item.largeparagraphcontent4">
    </div>

    <div class="homepage_wrapperContainer">
      <div class="homepageContainer3" [innerHTML]="content1$ | async">
      </div>
      <div class="homepageContainer4" [innerHTML]="content2$ | async">
      </div>
    </div>
  </div>
  </section>
}
}

<!--we focus section Start-->
@if (showFocusSection$ | async) {
@if (broughtybData | async; as item) {
@if (item.uid === "seqirus-homepage-focus-Component"){
<section class="homepage_vaccineBanner" id="homepage_vaccineBanner">
  <div id="vaccine-row" class="row g--grey-0 reverse-xs">
    <div class=" vaccine_row_img_col">
      <picture>
        <source [srcset]="getImage(item.media.widescreen)" media="(min-width: 1700px)">
        <source  [srcset]="getImage(item.media.tablet)" media="(min-width: 1024px) and (max-width:1399px)">
        <img  class="flu-vaccine--image" alt="Flu vaccine creation" [src]="getImage(item.media.desktop)">
      </picture>
    </div>
    <div class=" vaccine_row_content_col">
      <div class="flu-vaccine--callout">
        <img class="rectangle-down" src="assets/images/red_rectangle_down.png">
        <p class="headLine" [innerHTML]="item.headline"></p>
        <img class="rectangle-up"  src="assets/images/red_rectangle_up.png">
      </div>
    </div>
  </div>
</section>  
}
}
}
<!--we focus section END -->

<!--About page section start-->
@if (publicnode$ | async; as item) {
  @if(item.uid==="SeqirusWhyFluDetailAboutComponent"){
    <section class="ukaboutpage" id="ukaboutpage">
      <div class="about_container" id="about_container">
        <div class="aboutContainer"  [innerHTML]="item.headline"></div>
        <div class="about_wrapperContainer" [innerHTML]="item.largeparagraphcontent2"></div>
      </div>
    </section>
  }
}